import { requestWWWForm, getRequestJSON, requestJSONForm, requestJson } from '../utils/ajax';
import NewAxios from '@/lib/newEnvironmentAxios';

//添加群组
export function addGroupRequest(data) {
  const url = '/unicom/smartHelmetGroup/saveGroupInfo';
  return requestWWWForm(url, data);
}

//删除群组
export function deleteGroupRequest(data) {
  const url = '/unicom/smartHelmetGroup/deleteGroupInfo';
  return requestWWWForm(url, data);
}

//编辑群组
export function editeGroupRequest(data) {
  const url = '/unicom/smartHelmetGroup/updateGroupInfo';
  return requestWWWForm(url, data);
}

//群组列表
export function getGroupList(data) {
  const url = '/unicom/smartHelmetGroup/queryGroupList';
  return getRequestJSON(url, data);
}

//获取区域列表
export function getRegionList(data) {
  const url = '/unicom/smartHelmet/smartHelmetSync';
  return requestWWWForm(url, data);
}

//设备列表
export function getDeviceList(data) {
  const url = '/unicom/smartHelmetGroup/queryGroupDeviceList';
  return getRequestJSON(url, data);
}

//删除设备
export function deleteDevice(data) {
  const url = '/unicom/smartHelmetGD/relDelById';
  return requestJson(url, data);
}

//同步设备
export function synchronizationDevice(data) {
  const url = '';
  return requestWWWForm(url, data);
}

//添加设备
export function addDevice(data) {
  const url = '';
  return requestWWWForm(url, data);
}

//根据roleId查询数据权限
export function getDataAuthorityByRoldId(data) {
  const url = '/unicom/smartHelmetRole/selectSmartHelmetRole';
  return requestWWWForm(url, data);
}

//保存数据权限
export function saveDataAuthority(data) {
  const url = '/unicom/smartHelmetRole/addSmartHelmetRole';
  return requestWWWForm(url, data);
}

//设备关联人员
export function deviceBindPerson(data) {
  const url = '/unicom/smartHelmet/bindUser';
  return requestJSONForm(url, data);
}

//设备未关联的人员
export function unBindPerson(data) {
  const url = '/unicom/smartHelmet/searchNotBindUserInfo';
  return requestJSONForm(url, data);
}

//设备已经关联的人员
export function alreadyBindPerson(data) {
  const url = '/unicom/smartHelmet/searchBindUserInfo';
  return requestJSONForm(url, data);
}
